<template>
  <b-nav-item-dropdown
    class="d-flex align-items-center navbar-action-item notification-dropdown"
    right
    no-caret
    menu-class="notification-dropdown-menu"
    @show="onShow">
    <template #button-content>
      <span class="notification-trigger" title="Notifications">
        <i class="ri-notification-3-line"></i>
        <span class="sr-only">Notifications</span>
        <span
          v-if="unread"
          class="notification-badge"
          :class="{ 'notification-badge-pulse': hasCritical }">
          {{ unreadLabel }}
        </span>
      </span>
    </template>

    <div class="notification-panel">
      <div class="notification-header">
        <span class="notification-header-title">
          Notifications
          <span v-if="unread" class="notification-count-pill">{{ unreadLabel }}</span>
        </span>
        <button
          type="button"
          class="notification-text-button"
          :disabled="!canMarkAll"
          title="Marks every notification up to the newest one shown as read"
          @click="markAllRead">
          Mark all read
        </button>
      </div>

      <div v-if="latestError" class="notification-error">
        <span>{{ latestError }}</span>
        <button type="button" class="notification-text-button" @click.stop="loadLatest">Retry</button>
      </div>

      <div v-if="latestLoading && !latest.length" class="notification-empty">
        <b-spinner small variant="primary" />
        <p>Loading notifications...</p>
      </div>
      <div v-else-if="!latest.length && !latestError" class="notification-empty">
        <i class="ri-notification-off-line"></i>
        <p>No notifications yet</p>
      </div>
      <div v-else-if="latest.length" class="notification-list">
        <b-dropdown-item
          v-for="item in latest"
          :key="item.id"
          class="notification-item"
          :link-class="{ 'is-static': !item.link }"
          @click="open(item)">
          <notification-item :item="item" :now-ms="nowMs" compact />
        </b-dropdown-item>
      </div>

      <b-dropdown-item class="notification-view-all" @click="viewAll">View all</b-dropdown-item>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import NotificationItem from '@/components/notification/NotificationItem.vue';
import { maxId } from '@/util/notificationInbox';

const COUNT_POLL_MS = 60 * 1000;

export default {
  name: 'NavbarNotifications',
  components: { NotificationItem },
  data() {
    return {
      nowMs: Date.now(),
      marking: false,
    };
  },
  computed: {
    unread() {
      return this.$store.getters['notificationInbox/unread'];
    },
    unreadLabel() {
      return this.unread > 99 ? '99+' : String(this.unread);
    },
    hasCritical() {
      return this.$store.getters['notificationInbox/hasCritical'];
    },
    latest() {
      return this.$store.getters['notificationInbox/latest'];
    },
    latestLoading() {
      return this.$store.getters['notificationInbox/latestLoading'];
    },
    latestError() {
      return this.$store.getters['notificationInbox/latestError'];
    },
    canMarkAll() {
      return this.unread > 0 && maxId(this.latest) !== null && !this.marking;
    },
  },
  mounted() {
    this.refreshCount();
    this.countPoll = setInterval(this.refreshCount, COUNT_POLL_MS);
  },
  beforeDestroy() {
    clearInterval(this.countPoll);
  },
  methods: {
    refreshCount() {
      this.nowMs = Date.now();
      this.$store.dispatch('notificationInbox/fetchCount');
    },
    onShow() {
      this.nowMs = Date.now();
      this.loadLatest();
    },
    loadLatest() {
      this.$store.dispatch('notificationInbox/fetchLatest');
    },
    open(item) {
      this.$store.dispatch('notificationInbox/openItem', { item, router: this.$router });
    },
    async markAllRead() {
      this.marking = true;
      const readAt = await this.$store.dispatch('notificationInbox/markAllRead', maxId(this.latest));
      this.marking = false;
      if (readAt) this.loadLatest();
    },
    viewAll() {
      this.$store.dispatch('notificationInbox/openLink', { link: '/notifications', router: this.$router });
    },
  },
};
</script>
